import { Popover } from 'antd';
import React, { useState } from 'react';
import Button from 'components/Button';

import './styles.less';

const SourcesList = ({ sources }) => (
  <div className="text-dark font-size-14">
    {sources.map((source) => (
      <div className="pdd-vertical-10 pdd-horizon-20 company-info-sources-list-item">
        {source.name || '-'}({source.total})
      </div>
    ))}
  </div>
);

const CompanyInfoSourcesPopover = ({ sources, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      overlayClassName="company-info-sources-popover"
      placement="topLeft"
      content={<SourcesList sources={sources} />}
      trigger="click"
      open={open}
      onOpenChange={setOpen}
    >
      <Button size="small" className="company-info-sources-button">
        {children}
      </Button>
    </Popover>
  );
};

export default CompanyInfoSourcesPopover;
